/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.FeatureStoreUsageRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './FeatureStoreUsageRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.FeatureStoreUsageRpc#getLimitUsageForHub
 */
export const GET_LIMIT_USAGE_FOR_HUB_QUERY_FIELD_NAME = 'com_hubspot_feature_store_rpc_FeatureStoreUsageRpc_getLimitUsageForHub';
export const GET_LIMIT_USAGE_FOR_HUB_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_LIMIT_USAGE_FOR_HUB_QUERY_FIELD_NAME,
  args: ['upgradeApiName'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getLimitUsageForHubRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.FeatureStoreUsageRpc#getLimitParcelMappings
 */
export const GET_LIMIT_PARCEL_MAPPINGS_QUERY_FIELD_NAME = 'com_hubspot_feature_store_rpc_FeatureStoreUsageRpc_getLimitParcelMappings';
export const GET_LIMIT_PARCEL_MAPPINGS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_LIMIT_PARCEL_MAPPINGS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getLimitParcelMappingsRpc, {
      timeout: ctx.timeout
    });
  }
});